import { createReducer , on } from '@ngrx/store';
import { Star, StarResponse } from 'src/app/models';
import { storeStarsFailure, storeStarsSuccess } from 'src/app/store/actions/stars/stars.actions';

export interface starsState {
    starRsponse: StarResponse
}

export const initialStarsState : StarResponse = new StarResponse() ;


export const StarsReducer = createReducer(
    
    initialStarsState,

    on(storeStarsSuccess , (state , { starsResponse })=>{

        return starsResponse;
    }),

    on(storeStarsSuccess , (state , { starsResponse })=>{

        return starsResponse;
    }),

    on(storeStarsFailure , (state , { error })=>{

        return { ...state, error: error, stars: [new Star()] };
    }),
)